/** @format */

import React from 'react';

// TODO
const SearchContextDefault = {
    listItems: [], // Our search results
    extraData: () => {}, // Extra data we might use from the search
    search: null, // Search text
    filters: () => {}, // Our filters
    error: false, // An err
    pending: false, // Pending search
    sort: null, // sort by
    direction: null, // direction to sort
    page: typeof '', // What page of results
    nextPage: false, // Do we have another page?
    lastModified: false,
    showResults: false, // Show the results, used for toggling, mainly for the quick search
    handleChangePaginationSize: () => {}, // Change the amount of items per page
    onSearch: () => {},
    onUpdate: () => {},
    onHideResults: () => {},
    onShowResults: () => {},
    isSearchActive: () => {},
    containerRef: () => {},
    handleUpdatePressId: () => {}, // Set the local storage press id and update the context
    handleRemoveItemFromList: () => {}, // Remove an item from the list
    handleChange: () => {},
    orders: [{}]
};
export default React.createContext(SearchContextDefault);

export {SearchContextDefault};
